<script>
export default {
    name: 'Spinner',
    props: {
        size: {
            type: [String, Number],
            default: undefined,
        },
    },
    mounted() {
        if (this.size !== undefined) {
            this.$refs.spinner.style.setProperty('--size', `${this.size}px`)
        }
    },
}
</script>

<template lang="pug">
.spinner(ref="spinner")
    div
        div

</template>
